{
  "slug": "analogies-practice",
  "title": "Verbal Analogies Practice",
  "description": "The same relationship must hold across both pairs. Work through examples, answers, and responsible practice advice.",
  "category": "Practice questions",
  "sections": [
    {
      "heading": "How to approach it",
      "paragraphs": [
        "The same relationship must hold across both pairs.",
        "Work accurately before quickly. State the rule, test every step, then compare choices."
      ]
    },
    {
      "heading": "Practice set",
      "paragraphs": ["Try each prompt before reading its answer or strategy."],
      "bullets": [
        "Bird : nest :: bee : hive.",
        "Glove : hand :: shoe : foot.",
        "Thermometer : temperature :: clock : time.",
        "Chapter : book :: scene : play.",
        "Generous : stingy :: ancient : modern.",
        "Sapling : tree :: calf : cow."
      ]
    },
    {
      "heading": "Practice effects",
      "paragraphs": [
        "Practice improves familiarity and strategy, but a short exercise is not a standardized assessment.",
        "Use unfamiliar material and time between sessions for a more honest snapshot."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "iq-score-ranges-explained"],
  "sources": [],
  "faqs": [
    {
      "question": "Does practice raise IQ?",
      "answer": "It can improve familiarity and specific strategies; that is not proof of broad permanent change."
    }
  ],
  "summary": "The same relationship must hold across both pairs. Work through examples, answers, and responsible practice advice. Content reviewed 18 July 2026."
}
